import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import React, { useState, useEffect } from "react";
import { api } from "../../../../api/api";
import SecretSantaFeedbackSendApproveDialog from "../../../dialog/SecretSantaFeedbackSendApproveDialog";
import { useSnackbar } from "notistack";

export function AdminControl(props) {

  const [feedbackSendDialog, openFeedbackSendDialog] = useState(false);
  const [feedbackSendApprove, setFeedbackSendApprove] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const snackBarAddMessage = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };


  const callSecretSantaChangeState = (state) => {
    let toState = state ? 'start' : 'finish';
    api.secretSanta.changeState(toState)
      .then(
        () => {
          props.setRequestSantaState(true)
          props.setReload(true)
        }
      )
      .catch((error) => {
        console.log(error)
        snackBarAddMessage(`Unable ${toState} secret santa, please check your permissions and try again. Error: ${error.status}`, 'error');
      })
  };

  useEffect(() => {
    if (feedbackSendApprove) {
      openFeedbackSendDialog(false)
      props.setBackdropOpen(true)
      api.sender.sendSecretSantasFeedback()
        .then(() => {
          setFeedbackSendApprove(false)
          props.setBackdropOpen(false)
        })
        .catch((error) => {
          console.log(error)
          snackBarAddMessage(`Unable make secret santa pairs, please check your permissions and try again. Error: ${error.status}`, 'error');
        })
        .finally(() => {
          props.setBackdropOpen(false)
        });
    }
  }, [feedbackSendApprove]);

  return <Paper sx={{
    mt: { xs: 2, md: 2 },
    mb: { xs: 2, md: 2 },
    p: 2,
  }}>
    <SecretSantaFeedbackSendApproveDialog
      component={'span'}
      open={feedbackSendDialog}
      handleClose={() => openFeedbackSendDialog(false)}
      handleApprove={() => setFeedbackSendApprove(true)}
    />
    <Typography variant="h6" gutterBottom>
      Secret Santa
    </Typography>
    {/*{notificationSend ? <label color="red">Santa notifications have been sent!!</label> : false}*/}
    <br />
    <Button onClick={() => callSecretSantaChangeState(true)}
            variant="contained"
            color="secondary"
            sx={{ mt: 3, ml: 1 }}
            disabled={props.santaState !== 0}>Start Secret Santa</Button>
    <Button onClick={() => callSecretSantaChangeState(false)}
            variant="contained"
            color="secondary"
            sx={{ mt: 3, ml: 1 }}
            disabled={props.santaState === 0}>Finish Secret Santa</Button>

    <Button
      onClick={() => openFeedbackSendDialog(true)}
      variant="contained"
      color="primary"
      sx={{ mt: 3, ml: 1 }}
    >
      Send feedback requests
    </Button>
  </Paper>;
}
